import { module } from 'modujs';
import p5 from 'p5';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.appendP5();

        this.innerWidth = window.innerWidth;
        this.checkResizeBind = this.checkResize.bind(this)
        window.addEventListener('resize', this.checkResizeBind)

        window.baillatClock = this
    }

    enable() {
        // console.log('clock is loaded');
        this.el.classList.add('is-loaded');
    }

    appendP5() {
        const that = this;

        const sketch = function(p) {
            let logoFont, numberFont;

            const parentWidth = that.el.getBoundingClientRect().width;

            p.preload = (_) => {
              logoFont = p.loadFont("/assets/fonts/BaillatStudio-Stencil.ttf");
              numberFont = p.loadFont("/assets/fonts/NeueMontreal-Regular.otf");
            };

            // intended typo,
            // to be replaced in the udpate function to get the ligature glyph
            const txtSrc = "Bai&atStudio";

            // measures are in pixels
            const measurement = {
              // clock graphics
              clockFaceRadius: 450/460 * parentWidth,
              clockStripesRadius: 214/460 * parentWidth,
              clockNumberRadius: 270/460 * parentWidth,
              clockLetterRadius: 360/460 * parentWidth,
              clockStripesLength: 20/460 * parentWidth,
              // runners
              hourLength: 150/460 * parentWidth,
              minuteLength: 220/460 * parentWidth,
              secondLength: 240/460 * parentWidth,
              offsetCenter: 40/460 * parentWidth,
              secondStroke: 2/460 * parentWidth,
              othersStroke: 10/460 * parentWidth,
              // text size
              clockFaceNumberSize: 18/460 * parentWidth,
              clockFaceTextSize: 74/460 * parentWidth,
            };

            p.setup = function() {
              //initialize canvas for p5
              p.createCanvas(parentWidth, parentWidth);

              // setting constant pixel density
              // to prevent issue with retina screen
              p.pixelDensity(2);

              // utils for the 2D context
              p.imageMode(p.CENTER);
              p.ellipseMode(p.CENTER);
              p.textAlign(p.CENTER, p.BASELINE);
              p.strokeCap(p.SQUARE);
              p.noStroke();

              that.el.append(p.canvas);
              that.enable();
            }

            p.draw = function() {
              // intro animation

              const numFrames = 2 * 60;
              const progress = InOutQuintic(p.constrain(p.frameCount / numFrames, 0, 1));
              const progressLetter = InOutQuadratic(p.constrain(p.frameCount / numFrames, 0, 1));

              // fetch actual time
              const t = new Date();
              const hr = t.getHours();
              const mn = t.getMinutes();
              const sc = t.getSeconds();

              // helpers to prevent repetition
              const step = p.TWO_PI / 60;
              const rotationOffset = -p.PI / 2 ;

              // clear canvas
              p.clear();
              // to be removed to make bg transparent
              // p.background(255);

              //centering the matrix
              p.translate(p.width / 2, p.height / 2);
              // rotate(p.TWO_PI * progress)
              //clock face background
              p.push();
              p.stroke(0)
              p.strokeWeight(1)
              p.fill(250);
              p.ellipse(0, 0, measurement.clockFaceRadius);
              p.pop();

              //clock face graphics
              let picker = 0;
              for (let i = 0; i <60 ; i++) {
                const id = (i / 60) * p.TWO_PI;
                let x = (p.cos(id) * measurement.clockStripesRadius) / 2;
                let y = (p.sin(id) * measurement.clockStripesRadius) / 2;
                p.push();
                p.stroke(0);
                p.strokeWeight(i % 5 === 0 ? 1.5 : 0.5);
                p.translate(x, y);
                p.rotate(id + p.PI / 2);
                p.line(
                  0,
                  -measurement.clockStripesLength / 2,
                  0,
                  measurement.clockStripesLength / 2
                );
                p.pop();

                if (i % 5 === 0) {
                  x = (p.cos(id - p.PI / 2) * measurement.clockNumberRadius) / 2;
                  y = (p.sin(id - p.PI / 2) * measurement.clockNumberRadius) / 2;
                  p.push();
                  const numberAdjustment = 6 / 460 * parentWidth;
                  p.textFont(numberFont);
                  p.textSize(measurement.clockFaceNumberSize);
                  p.translate(x, y + numberAdjustment);
                  const numbers = i === 0 ? 60 : i;
                  p.text(numbers, 0, 0);
                  p.pop();
                  x = (p.cos(id - p.PI / 2) * measurement.clockLetterRadius) / 2;
                  y = (p.sin(id - p.PI / 2) * measurement.clockLetterRadius) / 2;
                  p.push();
                  const logoTextAdjustment = 24 / 460 * parentWidth;
                  p.textFont(logoFont);
                  p.textSize(measurement.clockFaceTextSize);
                  p.translate(x, y + logoTextAdjustment);
                  const logoLetters = txtSrc[picker % txtSrc.length];
                  if (logoLetters === "&") {
                    /* super hacky way to draw a specific glyph on screen since the font doesn't have a Unicode for the ligatures */
                    const ligature = logoFont.font.glyphs.glyphs[154];
                    const bounds = (ligature.getBoundingBox().x2 / 460 * parentWidth - ligature.getBoundingBox().x1 / 460 * parentWidth);
                    ligature.draw(
                      p.drawingContext,
                      (-bounds / measurement.clockFaceTextSize) * 2,
                      0,
                      measurement.clockFaceTextSize
                    );
                  } else {
                    p.text(logoLetters, 0, 0);
                  }

                  p.pop();
                  picker++;
                }
              }

              //second runner
              p.push();
              p.stroke(0);
              p.strokeWeight(measurement.secondStroke);
              const secondAngle = (sc / 60) * p.TWO_PI;
              p.rotate(secondAngle + rotationOffset + (1-progress)*p.TWO_PI);
              p.translate(-measurement.offsetCenter, 0);
              p.line(0, 0, measurement.secondLength * progress, 0);
              p.pop();

              //minutes runner
              p.push();
              p.stroke(0);
              p.strokeWeight(measurement.othersStroke);
              const minutesAngle = (mn / 60) * p.TWO_PI;
              p.rotate(minutesAngle + rotationOffset + (1-progress)*p.TWO_PI);
              p.translate(-measurement.offsetCenter, 0);
              p.line(0, 0, measurement.minuteLength * progress, 0);
              p.pop();

              //hours runner
              p.push();
              p.stroke(0);
              p.strokeWeight(measurement.othersStroke);
              const hoursAngle = ((hr % 12) / 12) * p.TWO_PI;
              p.rotate(hoursAngle + rotationOffset - (1-progress)*p.TWO_PI);
              p.translate(-measurement.offsetCenter, 0);
              p.line(0, 0, measurement.hourLength * progress, 0);
              p.pop();
            }

            function InOutQuadratic(p) {
              var m = p - 1,
                t = p * 2;
              if (t < 1) return p * t;
              return 1 - m * m * 2;
            }

            function InOutBack      (p) { var m=p-1,t=p*2, k = 1.70158 * 1.525; if (p < 0.5) return p*t*(t*(k+1) - k); else return 1 + 2*m*m*(2*m*(k+1) + k); }

            function InOutQuintic   (p) { var m=p-1,t=p*2; if (t < 1) return p*t*t*t*t;       return 1+m*m*m*m*m      * 16; }
        }

        this.pInstance = new p5(sketch);
    }

    removeP5() {
        this.pInstance.remove();
        this.pInstance = null;
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true
            requestAnimationFrame(() => {
                this.resize()
                this.resizeTick = false
            })
        }
    }

    resize() {
        const windowWidth = window.innerWidth
        if(this.innerWidth == windowWidth && this.innerWidth < 1024) return;
        this.innerWidth = windowWidth;

        this.removeP5()
        this.appendP5();
    }

    destroy() {
        window.removeEventListener('resize', this.checkResizeBind)
        this.removeP5();
    }
}
